<div *ngIf="loginDisplay && mensagem" class="card m-3 stretch-card">
	<div class="card-header card-header-customer py-4 px-0">
		<h4 class="title">Editor de mensagem</h4>
	</div>
	<div class="card-body py-5">
		<form class="forms-sample">
			<div class="form-group border-info div-ckeditor">
        <quill-editor [(ngModel)]="mensagem.texto" name="texto" id="texto" [theme]="'snow'"></quill-editor>
				<!-- <ckeditor [editor]="Editor" [config]="config" data="{{ mensagem.texto }}" id="texto" formControlName="texto"></ckeditor> -->
			</div>

		</form>

	</div>
  <div style="margin-top: 2rem; margin-right: 0.8rem; display: flex; justify-content: end; ">
    <button type="button" class="btn btn-info btn-customer-info btn-customer-edit float-right" (click)="onUpdate(mensagem)">
      <em i-bs name="pen-fill"></em>
    </button>
  </div>
</div>
